import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './components/main/main.component';
import { VersionForVisuallyImpairedRoutes } from './models/routes';

const childRoutes: Routes = [
  {
    path: VersionForVisuallyImpairedRoutes.DataSet,
    loadChildren: () => import('./modules/data/data.module').then(x => x.DataModule)
  },
  {
    path: VersionForVisuallyImpairedRoutes.Apps,
    loadChildren: () => import('./modules/apps/apps.module').then(x => x.AppsModule)
  },
  {
    path: VersionForVisuallyImpairedRoutes.News,
    loadChildren: () => import('./modules/news/news.module').then(x => x.NewsModule)
  },
  {
    path: VersionForVisuallyImpairedRoutes.Information,
    loadChildren: () => import('./modules/information/information.module').then(x => x.InformationModule)
  }
];

export const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: childRoutes
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RoutingModule {}
